import {
  NotificationToast,
  Spinner,
  Application,
  Card,
  Display,
  Tab,
  MessageBox,
  ICanvasError,
  ErrorDialog,
  Confirm,
  Layout,
  ButtonGroup,
  RecordHeader,
  ColorSwatch,
  Column,
  DataGrid,
  EmptyState,
  FileUpload,
  FilterBox,
  Icon,
  Line,
  NavLink,
  Panel,
  RadioButtons,
  RecordTabs,
  TabSet,
  Timeline,
  Url,
  Screen,
  Spacer,
  Text,
} from "./ktm-ui";
import { KTMApi } from "api/KTMApi";
import { Dialog } from "ktm-ui";
import { Navigator } from "ktm-ui/components/Navigator";
import Signin from "ktm-ui/components/Signin";
import { ISigninProps } from "ktm-ui/core/Application";
import { BrowserRouter, Route } from "react-router-dom";
import { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./styles/Funding.css";
import "./styles/PlanAdminPortal.css";
import { Button, Modal } from "react-bootstrap";
import toastr from "toastr";
import FloatingHelpButton from "./ktm-ui/components/FloatingHelpButton"; 

Application.addComponents("UI", {
  Card,
  Display,
  Tab,
  Layout,
  Button,
  DialogHeader: Dialog.Header,
  DialogFooter: Dialog.Footer,
  ButtonGroup,
  RecordHeader,
  ColorSwatch,
  Column,
  DataGrid,
  EmptyState,
  FileUpload,
  FilterBox,
  Icon,
  Line,
  NavLink,
  Panel,
  RadioButtons,
  RecordTabs,
  TabSet,
  Timeline,
  Screen,
  Spacer,
  Text,
});

Application.instance.getMessageBox = () => MessageBox as any;
Application.instance.getConfirmDialog = () => Confirm as any;
Application.instance.doPostRequest = KTMApi.doPostRequest;
Application.instance.renderError = (error: ICanvasError) => (
  <ErrorDialog error={error} />
);
Application.instance.host = "";
Application.instance.renderSignin = (props: ISigninProps) => {
  return (
    <Signin
      app={props.app}
      done={props.done}
      token={props.token}
      settings={props.app.signinSettings}
    />
  );
};

function App() {

  const homeStyle = {
      backgroundColor: "#f0f2f4",
      margin: "auto",
      height: "100vh",
  };

  return (
    <div className="App">
      <NotificationToast />
      <Spinner />
        <div style={homeStyle}>
          <BrowserRouter>
            <Route path="/" render={(routeProps) => <RenderNavigator routeProps={routeProps} />} />
          </BrowserRouter>
          <FloatingHelpButton/> 
        </div>
    </div>
  );
}

function RenderNavigator(props) {
  const [showSettings, setShowSettings] = useState(false);
  const [selectedPolicyHolder, setSelectedPolicyHolder] = useState(null);
  const [showBanner, setShowBanner] = useState(null);
  const location = props.routeProps.location;
  const parsed = Url.parse(location.pathname, location.search);
  const brandInfo = useBrandInfo(location.pathname, location.search);
  const policyHolders = usePolicyHolders(parsed.screen);
  const enableTwoFactor = useUserInfo(parsed.screen);

  useEffect(() => {
    const policyId = extractPolicyId(props.routeProps.location.search);
    setSelectedPolicyHolder(policyId);
  }, [props.routeProps.location.search]);

  let urlPath = location.pathname;
  if (parsed.screen === "undefined") parsed.screen = undefined;

  if (urlPath === "/") window.location.href = "/ops";

  const isWithinLast30Days = (dateString) => {
    const firstSignInDate = new Date(dateString);
    const currentDate = new Date();
    const differenceInTime = currentDate.getTime() - firstSignInDate.getTime();
    const differenceInDays = differenceInTime / (1000 * 60 * 60 * 24);

    return differenceInDays <= 30;
  };
  
  const getSignInDetails = async () => {
    try {
      const response = await fetch("/api/PlanAdmin/getfirstsignin");
      const res = await response.json();
      if (res.success) {
        if (isWithinLast30Days(res.firstSignInDate)) {
          setShowBanner(true);
        } else {
          setShowBanner(false);
        }
      } else {
        throw new Error("Failed to fetch data");
      }
    } catch (error) {
      console.error(error);
      return false;
    }
  }
  
  useEffect(() => {
    getSignInDetails();
  }, []);

  const customLogoStyle = brandInfo.brandLogo !== "/nhclogo.png" ? { padding: "0" } : {};

  let navigatorDisplay = !parsed.screen ? "none" : "block";

  const handleExit = () => {
    setShowBanner(false);
  };

  return (
    <>
      {showBanner &&
      <div className="p-2" style={{backgroundColor: "#abdbe3"}}>
        <h2>New to National HealthClaim? Book a 30 minute 
          <a style={{textDecoration: "underline", color: "blue"}}
             href="https://calendly.com/training-nationalhealthclaim/30min"> Plan
            Administration Training Session</a> today!</h2>
        <button
            onClick={handleExit}
            style={{
              position: "absolute",
              top: "10px",
              right: "10px",
              background: "none",
              border: "none",
              color: "white",
              fontSize: "16px",
              cursor: "pointer",
            }}
            aria-label="Don't show this again"
        >
          ×
        </button>
      </div>
      }
      <div style={{display: "flex", flexDirection: "column"}}>
        {showSettings && (
            <SettingsModal
                onClose={() => setShowSettings(false)}
                onSubmit={async (policy_id, setAsDefault, enable2fa) => {
                  if (policy_id) {
                    if (setAsDefault) {
                      try {
                        await setDefaultPolicy(policy_id);
                      } catch (error) {
                        console.error("Failed to set default policy:", error);
                      }
                    }
                    setSelectedPolicyHolder(policy_id);
                  }
                
                  if (enable2fa !== null) {
                    await setEnable2fa(enable2fa);
                  }
                
                  setShowSettings(false);
                  props.routeProps.history.push(`/ops/planadmin.policy.record?policy_id=${policy_id}`);
                  window.location.reload();
                }}
          policyHolders={policyHolders}
          enable2fa={enableTwoFactor}
          selectedPolicyHolder={selectedPolicyHolder}
        />
      )}
      <div className="nhc-nav-bar" style={{backgroundColor:brandInfo.brandColor}}>
        <div>
          <img className="nav-logo" src={brandInfo.brandLogo} style={customLogoStyle}></img>
        </div>
        <div
          style={{
            alignItems: "flex-end",
            marginRight: 15,
            marginTop: 15,
          }}
        >
          {(policyHolders != null) && (
            <button
              onClick={() => setShowSettings(!showSettings)}
              style={{ borderRight: "1px solid #e0e0e0", paddingRight: 15}}
            >
              Settings
            </button>
          )}
          <button
            style={{ paddingLeft: 15}}
            onClick={() => Application.instance.session.signout()}
          >
            Logout
          </button>
        </div>
      </div>
      <div style={{ flexGrow: 1 }}>
        <div key="navigator" style={{ display: navigatorDisplay }}>
          <Navigator
            appName={parsed.app}
            domain={parsed.domain}
            screen={parsed.screen}
            branch={parsed.branch}
            screenProps={parsed.search}
            history={props.routeProps.history}
          />
        </div>
      </div>
    </div>
    </>
  );
}

async function fetchAndParseUrl(path, search, resource) {
  let parsed = Url.parse(path, search);
  if (parsed.screen === "undefined") {
    parsed.screen = undefined;
    return;
  }
  
  if(parsed.search.policy_id === undefined) return;
  
  const response = await fetch(`/api/Settings/${resource}?policyId=${parsed.search.policy_id}`);
  const res = await response.json();
  if (res.success) {
    return res;
  } else {
    throw new Error('Failed to fetch data');
  }
}

async function setDefaultPolicy(policyId) {
  try {
    const requestOptions = {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        PolicyId: policyId,
      }),
    }

    await fetch('/api/PlanAdmin/setdefaultpolicy', requestOptions )
        .then((response) => response.json())
        .then((data) => {
          if(data.success)
          {
            toastr.success(data.message, "Success");
          } else {
            toastr.error("Failed to update default company.");
          }
        });

  } catch (error) {
    console.error('Error setting default policy');
  }
}

async function setEnable2fa(enable2Fa) {
  try {
    const requestOptions = {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        enable2Fa: enable2Fa,
      }),
    }

    await fetch('/api/PlanAdmin/setenable2fa', requestOptions )
        .then((response) => response.json())
        .then((data) => {
          if(data.success)
          {
            toastr.success(data.message, "Success");
          } else {
            toastr.error("Failed to enable 2FA.");
          }
        });

  } catch (error) {
    console.error('Error enabling 2FA');
  }
}

function useBrandInfo(pathname, search) {
  const [brandLogo, setBrandLogo] = useState("/nhclogo.png");
  const [brandColor, setBrandColor] = useState("#fff");
  const [error, setError] = useState(null);

  useEffect(() => {

    async function getBrandLogo() {
      try {
        const res = await fetchAndParseUrl(pathname, search, 'getcompanybrandlogo');
        setBrandLogo("https://nhcfilestorage.blob.core.windows.net/images/"+res.companyBrandLogo);
      } catch (error) {
        setError(error);
      }
    }

    async function getBrandColor() {
      try {
        const res = await fetchAndParseUrl(pathname, search, 'getcompanybrandcolor');
        setBrandColor(res.companyBrandColor);
      } catch (error) {
        setError(error);
      }
    }
  
    getBrandLogo();
    getBrandColor();
  }, [pathname, search]);

  return {brandLogo, brandColor, error};
}

function SettingsModal(props) {
  const [selectedPolicyHolder, setSelectedPolicyHolder] = useState(
    props.selectedPolicyHolder || (props.policyHolders[0] && props.policyHolders[0].policyId)
  );
  const [setAsDefault, setSetAsDefault] = useState(false);
  const [enable2fa, setEnable2fa] = useState(props.enable2fa);

  useEffect(() => {
    const policyHolder = props.policyHolders.find(ph => ph.policyId === selectedPolicyHolder);
    if (policyHolder) {
      setSetAsDefault(policyHolder.isDefault);
    }
  }, [selectedPolicyHolder, props.policyHolders]);

  const submit = () => {
    const hasPolicyChanged = selectedPolicyHolder !== props.selectedPolicyHolder;
    const hasEnable2faChanged = enable2fa !== props.enable2fa;
    const hasSetAsDefaultChanged = setAsDefault !== (props.policyHolders.find(ph => ph.policyId === selectedPolicyHolder)?.isDefault || false);
  
    if (!hasPolicyChanged && !hasSetAsDefaultChanged && hasEnable2faChanged) {
      props.onSubmit(selectedPolicyHolder, null, enable2fa);
    } else {
      props.onSubmit(selectedPolicyHolder, setAsDefault, hasEnable2faChanged ? enable2fa : null);
    }
  };  

  return (
    <Modal
      show={true}
      className="pa-settings-modal"
      onHide={props.onClose}
      style={{top:100}}
    >
      <Modal.Header>
        <Modal.Title style={{fontSize:"17px"}}>Settings</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="fundingv2-card fundingv2-card--form">
        {props.policyHolders.length > 1 && (
          <div className="fundingv2-field">
            <label htmlFor="settings-policy-holder">Policy Holders</label>
            <select
              id="settings-policy-holder"
              className="fundingv2-input"
              value={selectedPolicyHolder}
              onChange={(e) => setSelectedPolicyHolder(e.target.value)}
            >
              {props.policyHolders.map((policyHolder) => (
                <option key={policyHolder.policyId} value={policyHolder.policyId}>
                  {policyHolder.name}
                </option>
              ))}
            </select>
          </div>
        )}
        {props.policyHolders.length > 1 && (
          <label className="fundingv2-consent">
            <input
              type="checkbox"
              checked={setAsDefault}
              onChange={(e) => setSetAsDefault(e.target.checked)}
            />
            Set selected policy holder as default
          </label>
        )}
        <label className="fundingv2-consent">
          <input
            type="checkbox"
            checked={enable2fa}
            onChange={(e) => setEnable2fa(e.target.checked)}
          />
          Enable Two Factor Authentication
        </label>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button type="button" className="fundingv2-btn fundingv2-btn--ghost" onClick={props.onClose}>Close</button>
        <button type="button" className="fundingv2-btn" onClick={submit}>Save</button>
      </Modal.Footer>
    </Modal>
  );
}

function extractPolicyId(input: string): string | null {
  const regex = /policy_id=([a-f0-9\-]+)/;
  const match = input.match(regex);
  
  return match && match.length > 0 ? match[1] : null;
}

function usePolicyHolders(screen) {
  const [policyHolders, setPolicyHolders] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function fetchData() {
      try {
        const response = await fetch("/api/PlanAdmin/assignedpolicies");
        const res = await response.json();
        if (res.success)
        {
          setPolicyHolders(res.policies.filter(x => x.enrollmentStatus?.toLowerCase() !== 'pending'));
        } else {
          throw new Error('Failed to fetch data');
        }
      } catch (error) {
        setError(error);
      }
    }
    fetchData();
  }, [screen]);

  return policyHolders;
}

function useUserInfo(screen) {
  const [enableTwoFactor, setEnableTwoFactor] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function fetchData() {
      try {
        const response = await fetch("/api/PlanAdmin/getuserinfo");
        const res = await response.json();
        if (res.success)
        {
          setEnableTwoFactor(res.twoFactorEnabled);
        } else {
          throw new Error('Failed to fetch user information');
        }
      } catch (error) {
        setError(error);
      }
    }
    fetchData();
  }, [screen]);

  return enableTwoFactor;
}

export default App;
